/* eslint-disable prettier */
/**
 * Created by calhosh on 4/14/2017.
 * KO resource file
 */
export const labels = {
	title: "EY Canvas Economics",
	status: "상태",
	header: "머리글",
	canvas: "Canvas",
	canvasEconomics: "Canvas Economics",
	badRequest: "잘못된 요청",
	errorBanner: "{0}개 오류",
	userProfileDropdown: {
		myProfile: "내 프로필",
		signOut: "로그아웃"
	},
	clientCode: "고객 코드",
	hours: "시간",
	local: "로컬",
	currency: "통화",
	rate: "요율",
	forecast: "예측",
	variance: "변동",
	edit: "편집",
	arrowUp: "위쪽 화살표",
	budget: "예산",
	priorBudget: "전기 예산",
	currentBudget: "당기 예산",
	summary: "요약",
	actual: "실제",
	priorActual: "전기 실제",
	currentActual: "당기 실제",
	remaining: "나머지",
	adjustment: "조정",
	estimate: "추정치",
	isRequired: "{0}은(는) 필수입니다",
	isPositiveInteger: "{0}은(는) 필수이며 음이 아닌 정수여야 합니다",
	isPositiveDecimal: "{0}은(는) 필수이며 소수점 이하 두 자리인 양수여야 합니다",
	in: "In",
	id: "ID",
	currentYear: "당기",
	priorYear: "전기",
	budgetHierarchy: "예산 체계",
	executionBudgetHierarchy: "실행 예산 체계",
	noContentAvailable: "사용 가능한 내용 없음",
	viewMore: "더 보기",
	budgetExecutionPhase: "{0} 내 모든 object에 대한 예산",
	details: "세부정보",
	unallocated: "미배정",
	none: "없음",
	thousands: "천",
	millions: "백만",
	lakhs: "십만",
	crores: "천만",
	budgetObjectName: "예산 Object 이름",
	editActivityCodes: "Activity 코드 편집",
	save: "저장",
	send: "보내기",
	cancel: "취소",
	searchActivityCodes: "Activity 코드 검색",
	noActivityCodesAvailable: "사용 가능한 activity 코드 없음",
	select: "선택",
	engagementCode: "Engagement 코드",
	engagementCodeName: "Engagement 코드 이름",
	activityCode: "Activity 코드",
	activityCodeDescription: "Activity 코드 설명",
	searchActivityCodesPlaceholderText: "Activity 코드 검색",
	addMember: "멤버 추가",
	closeLabel: "닫기",
	cancelLabel: "취소",
	seachInputRequired: "검색 입력 필요",
	nameOrEmail: "이름 또는 이메일",
	emailForExternal: "이메일",
	noRecord: "결과를 찾을 수 없습니다",
	userSearchPlaceholder: "결과를 보려면 이름이나 이메일을 입력하고 Enter 키를 누르십시오",
	userSearchPlaceholderForExternal: "이메일을 입력하고 Enter 키를 눌러 결과를 보십시오",
	clearAllValues: "모든 값 처리",
	clear: "처리",
	inValidEmail: "유효한 이메일을 입력하십시오",
	invalidClientCode: "유효하지 않은 고객 코드",
	railSearchText: "검색",
	open: "Open",
	remove: "제거",
	leave: "나가기",
	delete: "삭제",
	markAsCompleted: "완료 표시",
	budgetedHours: "예산 시간",
	forecastedHours: "예측 시간",
	actualHours: "실제 시간",
	ftaVariance: "FTA 차이",
	ftaVarianceTooltip: "예측 대 실적 차이",
	usedHours: "사용 시간",
	etcHours: "ETC 시간",
	createProjectCard: "프로젝트 생성",
	plusClients: "+{0} 고객",
	plusCodes: "+{0} 고객 코드",
	clientNames: "고객 이름:",
	clientName: "고객 이름:",
	clientNameLabel: "고객 이름",
	clientCodes: "고객 코드:",
	clientCodeCard: "고객 코드:",
	financialAnalysis: "재무 분석",
	billingExpenses: "청구 & 비용",
	independence: "독립성",
	timeChargedCanvasIndependenceStatus: "EY Canvas 및 재무코드별 전반적인 프로젝트 독립성 상태",
	independenceStatusFromCanvasLabel: "EY Canvas 독립성 상태",
	independenceRequired: "독립성 필요",
	validatedCanvas: "EY Canvas에서 검증됨",
	notInvited: "초대되지 않음",
	notApplicable: "해당 없음",
	incomplete: "미완료",
	other: "기타",
	financialCodesDisplayed: "재무코드 표시됨",
	independenceStatusChangeReasonLabel: "상태 변경",
	independenceStatusChangeReasonDescription: "선택한 팀 멤버에 대한 완료 사유를 선택하십시오",
	changeReasonLabel: "사유",
	clarificationLabel: "설명 (선택사항)",
	characterCount: "200자 중 {0}",
	expandAll: "모두 확장",
	collapseAll: "모두 축소",
	canvasEngagements: "EY Canvas engagement",
	independenceCompleted: "독립성 완료됨",
	engagementName: "Engagement 이름",
	engagementIndependenceStatus: "Engagement 독립성 상태 기준",
	noAssociatedClients: "연결된 고객이 없습니다",
	noCanvasEngagementsIdentified: "식별한 EY Canvas engagement 없음",
	placeholderForSearch: "팀 멤버 검색",
	exportToExcel: "Excel로 내보내기",
	all: "모두",
	updateSelected: "업데이트 선택됨",
	updateAll: "모두 업데이트",
	customizeTable: "표 수정",
	canvasEngagementName: "EY Canvas engagement 이름",
	displayBy: "데이터 표시 기준",
	financialDetails: "세부재무정보",
	actualHoursToDate: "누적 실제 시간",
	byWeekEndingDate: "주 종료일 기준",
	ClickAndDrag: "확대하려면 차트에서 영역을 클릭한 후 끌어당기십시오",
	etc: "완료 예상 시간",
	auditProgress: "EY Canvas 진행상태",
	tasksAndMilestones: "Task & Milestone",
	milestonesOverdue: "Milestone 지연",
	milestoneOverdue: "Milestone 지연",
	inProgress: "진행 중",
	inReview: "리뷰 중",
	Complete: "완료",
	assignments: "배정",
	assignment: "배정",
	assignmentsOverdue: "배정 지연",
	assignmentOverdue: "배정 지연",
	overdue: "지연",
	requestOverdue: "요청 지연",
	requestsOverdue: "요청사항 지연",
	total: "합계",
	complete: "완료",
	closed: "닫힘",
	Unassigned: "배정되지 않음",
	unassigned: "배정되지 않음",
	sent: "전송됨",
	totalTask: "총 Task",
	collaboration: "공동작업",
	received: "수신됨",
	accepted: "수락됨",
	outstanding: "처리 전",
	unsentDrafts: "미전송 초안",
	draft: "초안",
	drafts: "초안",
	returned: "반송됨",
	draftRequests: "초안 요청사항",
	percent: "퍼센트",
	preparer: "작성자",
	reviewer: "검토자",
	NoDataForSelectedOptions: "선택한 옵션에 사용 가능한 정보 없음",
	NoAssignmentDataForSelectedOptions: "Engagement에서 배정 기능을 사용하지 않습니다",
	NoCollabDataForSelectedOptions: "Engagement에서 공동작업 기능을 사용하지 않습니다",
	tasks: "Task",
	totalTasks: "총 task",
	requests: "요청사항",
	requestSent: "요청사항 전송됨",
	requestsSent: "요청사항 전송됨",
	expandDetails: "세부정보 확장",
	onlyProjectAdministratorsCanEdit: "프로젝트 관리자만 편집할 수 있습니다",
	onlyProjectAdministratorsCanDelete: "프로젝트 관리자만 프로젝트를 삭제할 수 있습니다",
	userOptions: "사용자 옵션",
	userOptionsDropdown: {
		userSettings: "사용자 설정",
		delegateAccess: "위임 관리",
		privacyNotice: "개인정보보호 고지",
		signOut: "로그아웃"
	},
	delegateToInstruction: "동료에게 접근권한을 위임하여, 귀하 대신 engagement를 검증하도록 합니다. 대리인은 귀하가 접근할 수 있는 engagement를 모두 검증할 수 있습니다.",
	delegateFromInstruction: "다음 사용자는 engagement 코드 검증 권한을 위임했습니다",
	delegateAccess: "대리인 관리",
	addDelegates: "대리인 추가",
	addAnother: "신규 대리인 추가",
	hideMyDelegate: "내 대리인 숨기기",
	showMyDelegate: "내 대리인 표시",
	duplicateUser: "대리인으로 이미 추가됨",
	informationRequired: "이 정보는 필수입니다",
	delegateTo: "위임받은 사람",
	delegateFrom: "위임한 사람",
	noDelegatesAdded: "추가된 대리인 없음",
	noDelegationReceived: "수신된 위임 없음",
	removeDelegateMessgae: "이 대리인을 제거하시겠습니까? 제거하고 나면, 더 이상 귀하를 대신해서 프로젝트를 생성할 수 없습니다.",
	removeDelegateTitle: "대리인 제거",
	delegate: "위임",
	saveAndClose: "저장 & 닫기",
	resetZoom: "확대/축소 재설정",
	exportData: "데이터 내보내기",
	rankCode: "Rank 코드",
	userGui: "사용자 GUI",
	email: "이메일",
	globalAnsr: "Global ANSR",
	globalCost: "Global cost",
	globalMargin: "Global margin",
	localAnsr: "Local ANSR",
	localCost: "Local cost",
	localMargin: "Local margin",
	weekEnding: "Week ending",
	welcomeToEconomics: "EY Canvas Economics에 오신 것을 환영합니다",
	adminPortal: "관리 포탈",
	home: "홈",
	enterFirstNameText: "사용자의 이름, 성 또는 이메일 주소를 입력한 후 Enter 키를 눌러 검색합니다",
	addBtn: "추가",
	cancelBtn: "취소",
	close: "닫기",
	selectRole: "역할",
	upsText: "Ups!",
	sufficientRightsToAccess: "이 페이지에 접근할 권한이 없습니다",
	detailedInformation: "세부 정보는 데이터가 제공되는 시점 차이로 인해 제시된 데이터 요약과 다를 수 있습니다",
	noResultFound: "검색 기준과 일치하는 결과가 없습니다",
	loading: "로드 중…",
	search: "검색",
	softwareUpdate: "소프트웨어 업데이트",
	updateLater: "나중에 업데이트",
	updateNow: "지금 업데이트",
	updateMsg: "EY Canvas Economics에서 지금 업데이트가 가능합니다. 업데이트를 다운로드하여 설치하려면 지금 업데이트를 선택하십시오. 페이지가 새로 고쳐집니다.",

	eycanvasEngagements: "EY Canvas engagement",
	eycanvasEngagement: "EY Canvas engagement",
	expandView: "보기 확장",
	noFinancialCodesDisplay: "표시할 재무코드 없음",
	expand: "확장",
	collapse: "축소",
	bulkSendIndependenceLabel: "독립성 확인 일괄 보내기",
	independenceStatusInviteUserLabel: "내부 팀 멤버를 독립성 전용으로 추가",
	independenceStatusInviteUserDescription: "아래 팀 멤버의 역할을 식별하십시오. 이 사용자는 독립성 전용으로 제한된 {0} Canvas engagement에 추가되고 독립성을 완료하라는 알림을 받습니다.",
	clickToInviteUser: "to send independence confirmation",
	click: "Click",
	invitePending: "초대 보류 중",
	engagementRolePlaceholder: "Engagement 역할",
	engagementRoleRequiredErrorMessage: "선택한 팀 멤버의 engagement 역할을 선택하십시오",
	engagementInvitationSuccessToastMessage: "독립성 확인을 전송했습니다",
	engagementInvitationFailureToastMessage: "독립성 확인이 전송되지 않았습니다. 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.",
	independenceInviteConfirmationMessage: "독립성 확인이 전송됐습니다. 응답이 보류 중입니다.",
	engagementRoleRequiredOverAllErrorMessage: "하나 이상의 사용자에 engagement 역할이 선택되지 않았습니다. 독립성 확인을 보내려면 드롭다운에서 engagement 역할을 선택하십시오.",
	administrativeContractor: "Administrative Contractor",
};

export const errors = {
	default: "오류가 발생했습니다. 헬프 데스크에 문의하십시오.",
	102: "유효하지 않은 프로젝트",
	106: "RBAC 승인 거부됨",

	1001: "사용자를 찾을 수 없습니다",
	1002: "사용자 모두 가져오기 호출 실패",
	1003: "사용자 GUI는 null일 수 없습니다",
	1004: "요청은 null일 수 없습니다",
	1005: "GUI가 동일한 사용자가 이미 있기 때문에 사용자를 생성할 수 없습니다",
	1006: "GUI가 동일한 사용자가 두 명 이상 발견됐습니다",
	1007: "사용자가 활동 상태가 아닙니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오",
	1008: "선택한 숫자 형식이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오",
	1009: "선택한 반올림 형식이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오",
	1010: "선택한 통화 형식이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오",
	1011: "선택한 날짜 형식이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오",
	1012: "선택한 언어 형식이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오",
	1013: "이름이 너무 짧거나 너무 깁니다. 다시 시도하십시오.",
	1014: "성이 너무 짧거나 너무 깁니다. 다시 시도하십시오.",
	1015: "선택한 음수 형식이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오",
	1016: "사용자가 존재하지 않기 때문에 사용자를 업데이트할 수 없습니다",
	1017: "사용자 기본 설정을 가져오는 동안 오류가 발생했습니다. API를 호출하지 못했습니다.",
	1018: "사용자를 생성하는 동안 오류가 발생했습니다. API를 호출하지 못했습니다.",
	1019: "사용자 기본 설정을 업데이트하는 동안 오류가 발생했습니다. API를 호출하지 못했습니다.",
	1020: "사용자가 활동 상태가 아닙니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
	1021: "선택한 테마 값이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
	1022: "선택한 통화 값이 유효하지 않습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
	1023: "사용자는 요청한 팀 멤버를 프로젝트에서 제거할 권한이 없습니다",
	1024: "대리 사용자를 생성하는 동안 오류가 발생했습니다. API 호출에 실패했습니다.",
	1025: "대리 사용자 목록은 비워 둘 수 없습니다",
	1026: "사용자\ 이름이 너무 길거나 너무 짧습니다",
	1027: "사용자\ GUI가 유효하지 않습니다",
	1028: "사용자\ 이메일 주소가 너무 길거나 너무 짧습니다",
	1029: "사용자 ID는 비워 둘 수 없습니다",
	1030: "사용자 이름은 비워 둘 수 없습니다",
	1031: "사용자 이메일 주소는 비워 둘 수 없습니다",
	1032: "사용자는 접근권한을 제거할 컬렉션의 대리인에 속하지 않습니다",
	1033: "사용자는 접근권한을 제거할 컬렉션의 위임자에 속하지 않습니다",
	1034: "사용자는 콜렉션의 대리인에 이미 속해 있습니다",
	1035: "사용자 ID 길이가 적합하지 않습니다. 올바른 사용자 ID로 다시 시도하십시오.",
	1036: "로그인한 사용자는 목록에 속할 수 없습니다. 나중에 다시 시도하십시오.",
	1040: "관리자 권한이 없습니다. 헬프 데스크에 문의하십시오.",

	7001: "Engagement 메타데이터 호출 실패",
	7006: "지금은 EY Canvas에 접속할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",

	8003: "CDS API에서 Engagement 세부정보를 가져오는 동안 오류가 발생했습니다",
	8006: "지금은 EY Canvas에 접속할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.",
	8004: "Engagement 코드를 찾을 수 없습니다. Mercury 코드라면 Engagement 유형이 포함됐는지 확인하십시오. 다시 시도하고 문제가 지속되면 헬프 데스크에 문의하십시오.",
	8007: "CDS API에서 engagement 세부정보를 가져오는 동안 오류가 발생했습니다",
	8008: "연결 실패. 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",

	9001: "요청은 null일 수 없습니다",
	9002: "프로젝트 고객 코드 필드는 null일 수 없습니다",
	9003: "프로젝트 이름 필드는 null일 수 없습니다",
	9004: "퍼센트 필드는 null일 수 없습니다",
	9005: "요율 필드는 null일 수 없습니다",
	9006: "예산에 선택한 참여가 연결되어 있지 않습니다",
	9007: "Engagement 고유 식별자는 null일 수 없습니다",
	9008: "Engagement 고객 이름은 null일 수 없습니다",
	9009: "Engagement 설명은 null일 수 없습니다",
	9010: "Engagement 고객 고유 식별자는 null일 수 없습니다",
	9011: "연결된 engagement 시스템은 null일 수 없습니다",
	9012: "연결된 engagement 고유 식별자는 null일 수 없습니다",
	9013: "연결된 engagement 이름은 null일 수 없습니다",
	9014: "연결된 engagement 고객 고유 식별자는 null일 수 없습니다",
	9015: "연결된 engagement 고객 이름은 null일 수 없습니다",
	9016: "연결된 engagement 추가한 사람은 null일 수 없습니다",
	9017: "하나 이상의 EY Canvas engagement가 유효하지 않습니다",
	9018: "하나 이상의 연결된 Engagement 코드가 유효하지 않습니다",
	9019: "프로젝트 퍼센트는 0보다 커야 합니다",
	9020: "프로젝트 퍼센트는 소수점 이하 2자리를 넘지 않아야 합니다",
	9021: "프로젝트 요율은 0보다 커야 합니다",
	9022: "프로젝트 ID가 유효하지 않습니다",
	9023: "재무 분석 호출 가져오기 실패",
	9024: "프로젝트 세부정보를 찾을 수 없습니다",
	9025: "머리글 호출 가져오기 실패",
	9026: "검색 기준과 일치하는 결과가 없습니다",
	9027: "유효하지 않은 집계 유형",
	9028: "현재 사용자는 프로젝트에 접근권한이 없습니다",
	9029: "프로젝트 청구 세부정보를 찾을 수 없습니다",
	9030: "프로젝트 재무 필터를 찾을 수 없습니다",
	9031: "사용자 이름이 너무 길거나 너무 짧습니다",
	9032: "사용자 GUI가 유효하지 않습니다",
	9033: "사용자 이메일 주서가 너무 길거나 너무 짧습니다",
	9034: "하나 이상의 팀 멤버에게 프로젝트 관리자 역할이 있어야 합니다",
	9035: "귀하는 프로젝트의 마지막 활동 프로젝트 관리자입니다. 랜딩 페이지에서 프로젝트를 제거하려면 삭제하십시오. 프로젝트를 삭제할 수 없다면 헬프 데스크에 문의하십시오.",
	9036: "EY Canvas engagement 하나 이상을 제거하십시오. 수가 {0}을(를) 초과합니다.",
	9037: "팀 멤버 수가 {0}을 초과하므로 일부를 제거하십시오",
	9038: "Engagement 수가 {0}을 초과하므로 일부를 제거하십시오",
	9039: "프로젝트 사용자 수는 0보다 커야 합니다",
	9040: "검증되지 않은 재무 코드는 null이거나 빈 문자열이 아니어야 하며, 길이가 50자를 초과할 수 없습니다",
	9041: "프로젝트 ID는 비워 둘 수 없습니다",
	9042: "삭제를 완료할 수 없습니다. 다시 시도하고 오류가 지속되면 헬프 데스크에 문의하십시오.",
	9043: "현재 사용자는 프로젝트 편집 권한이 없습니다",
	9044: "프로젝트 재무 세부정보 호출 실패",
	9045: "프로젝트 상태가 유효하지 않습니다",
	9046: "프로젝트 사용자 상태가 유효하지 않습니다",
	9047: "유효하지 않은 프로젝트 사용자 역할",
	9048: "프로젝트 이름은 500자 이내여야 합니다",
	9049: "프로젝트 사용자 이름은 비워둘 수 없습니다",
	9050: "프로젝트 사용자 성은 비워둘 수 없습니다",
	9051: "프로젝트 사용자 GUI는 비워둘 수 없습니다",
	9052: "프로젝트 사용자 이메일은 비워둘 수 없습니다",
	9053: "프로젝트 사용자 관리 플래그는 비워둘 수 없습니다",
	9054: "특별 계정은 프로젝트 사용자로 추가될 수 없습니다",
	9055: "프로젝트 비용 필터를 찾을 수 없습니다",
	9056: "프로젝트 독립성 패치 요청 본문은 비워둘 수 없습니다",
	9058: "재무 코드가 유효하지 않습니다",
	9063: "독립성 완료에 유효하지 않은 근거 값이 있습니다",
	9064: "독립성 완료 유형에 유효하지 않은 값이 있습니다",
	9065: "프로젝트 비용 필터를 찾을 수 없습니다",
	9066: "프로젝트에 링크된 engagement ID 수가 최대 허용치를 초과합니다",
	9067: "유효하지 않은 패치 작업",
	9068: "일부 사용자가 상태를 이미 업데이트했습니다. 최근 상태를 보려면 페이지를 새로 고침하십시오.",
	9069: "독립성 패치 API 실패",
	9070: "Canvas engagement에 중복된 재무 코드가 연결됨",
	9071: "Canvas engagement에 연결된 단일 재무 코드만 주 코드로 표시시할 수 있습니다",
	9072: "Canvas engagement에 연결된 주 재무 코드가 유효하지 않습니다",
	9073: "중복되고 검증되지 않은 재무 코드",
	9074: "중복 사용자",
	9075: "사용자 이메일이 유효하지 않습니다",
	9076: "Engagement 사용자 생성기 요청 본문은 비워둘 수 없습니다",
	9077: "Engagement 사용자 생성 요청에 중복 사용자가 있습니다",
	9078: "Engagement 사용자 역할이 유효하지 않습니다",
	9079: "유효하지 않은 canvas engagement",
	9080: "프로젝트에 매핑되지 않은 engagement",
	9081: "Engagement 사용자 생성 요청 실패",
	9082: "활동이 없어 세션 시간이 초과됐습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면, 헬프 데스크에 문의하십시오.",

	/*Admin error codes*/
	14001: "사용자를 찾을 수 없습니다",
	14002: "관리자 호출 실패",
	14003: "발견된 관리자는 비활동 상태입니다",
	14004: "관리자 생성 실패",
	14005: "이름이 너무 짧거나 너무 깁니다. 다시 시도하십시오.",
	14006: "성이 너무 짧거나 너무 깁니다. 다시 시도하십시오.",
	14007: "관리자 역할 ID가 유효하지 않습니다",
	14008: "선택한 사용자가 이미 관리자입니다. 검토하십시오.",
	14009: "관리자 검색 호출 실패",
	14010: "사용자 GUI는 비워둘 수 없습니다",
	14011: "사용자 GUI는 0보다 커야 합니다",
	14012: "사용자 ID가 유효하지 않습니다. 다시 시도하십시오.",
	14013: "이메일 주소가 유효하지 않습니다. 다시 시도하십시오.",
	14014: "로그인한 사용자가 관리자와 동일하지 않습니다",
	14015: "관리 프로젝트 검색 호출 실패",
	14016: "관리자가 이미 존재하지만 비활동 상태입니다",
	14017: "관리자는 특별 사용자 계정만 될 수 있습니다",
	14018: "관리자 역할 ID는 비워둘 수 없습니다",
	14019: "로그인한 사용자는 시스템 관리자가 아닙니다",
	14020: "유효하지 않은 요청자 특별 계정입니다",
	14021: "관리자는 특별 사용자 계정만 될 수 있습니다",
	14023: "기존 관리자 역할을 제거하는 동안 오류가 발생했습니다",
	14024: "업데이트된 관리자 역할을 추가하는 동안 오류가 발생했습니다",
	14025: "관리자 사용자 ID는 비워둘 수 없습니다",

	/*PAANS error codes*/
	15001: "지금은 EY 정책 작성, 승인 및 알림 서비스를 사용할 수 없습니다. 따라서 관련 정책이 모두 완료됐는지 확인할 수 없습니다. 관련 정책을 검토하지 않았다면, 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오."
};

export const roundingOptions = [{
	value: 'none',
	label: "없음"
},
{
	value: 'thousands',
	label: "천"
},
{
	value: 'millions',
	label: "백만"
},
{
	value: 'lakhs',
	label: "십만"
},
{
	value: 'crores',
	label: "천만"
}
];

export const displayLanguages = [{
	displayLanguageId: 1,
	label: "English",
	value: 'en-us'
},
{
	displayLanguageId: 4,
	label: "Français",
	value: 'fr-ca'
},
{
	displayLanguageId: 5,
	label: "Español",
	value: 'es'
},
{
	displayLanguageId: 7,
	label: "Português",
	value: 'pt-br'
},
{
	displayLanguageId: 8,
	label: "Japanese",
	value: 'ja'
},
{
	displayLanguageId: 9,
	label: "Chinesezh-cn",
	value: 'zh-cn'
},
{
	displayLanguageId: 10,
	label: "Chinesezh-tw",
	value: 'zh-tw'
},
{
	displayLanguageId: 11,
	label: "Hebrew",
	value: 'he'
},
{
	displayLanguageId: 12,
	label: "Korean",
	value: 'ko'
}
];

export const numberFormats = [{
	value: '1,234,567,890',
	label: "numbericStlye1",
	title: '1,234,567,890'
},
{
	value: '1.234.567.890',
	label: "numbericStlye3",
	title: '1.234.567.890'
},
{
	value: '1,23,45,67,890',
	label: "numbericStlye7",
	title: '1,23,45,67,890'
},
{
	value: '1 234 567 890',
	label: "numbericStlye2",
	title: '1 234 567 890'
}
];

export const dateFormats = [{
	value: 'MM/dd/yyyy',
	label: 'MM/DD/YYYY'
},
{
	value: 'dd/MM/yyyy',
	label: 'DD/MM/YYYY'
},
{
	value: 'yyyy/MM/dd',
	label: 'YYYY/MM/DD'
}
];

export const negativeNumberFormats = [{
	value: '(1.1)',
	label: '(1.1)'
},
{
	value: '-1.1',
	label: '-1.1'
},
{
	value: '- 1.1',
	label: '- 1.1'
},
{
	value: '1.1-',
	label: '1.1-'
},
{
	value: '1.1 -',
	label: '1.1 -'
}
];

export const currencyFormats = [{
	value: "global",
	label: "Global"
},
{
	value: "local",
	label: "Local"
}
];

export const themeOptions = {
	light: "라이트",
	dark: "다크"
};

export const currencyOptions = {
	global: "Global",
	local: "로컬"
};

export const currencyDisplayOptions = [{
	value: 'Global',
	label: "Global"
},
{
	value: 'Local',
	label: "로컬"
}
];

export const statusValues = [{
	isActive: true,
	label: "활동"
},
{
	isActive: false,
	label: "비활동"
}
];

export const financialOptions = {
	serviceLine: "서비스라인",
	subServiceLine: "서브서비스라인",
	teamMember: "팀 멤버",
	rank: "직급"
};

export const roles = {
	1: "PARTNER IN CHARGE",
	2: "Engagement Partner",
	3: "Executive Director",
	4: "PRINCIPAL",
	5: "SENIOR MANAGER",
	6: "Manager",
	7: "SENIOR",
	8: "Staff",
	9: "Intern",
	10: "Engagement Quality Reviewer",
	11: "OTHER PARTNER",
	12: "GDS - Staff",
	13: "Advisory (ITRA,TAS,Human Capital or Other)",
	14: "Tax",
	15: "Executive Support Services",
	16: "General Counsel",
	17: "Audit Quality Reviewer",
	21: "Internal Audit Supervisor",
	22: "Internal Audit Staff",
	23: "Regulator",
	24: "Other (e.g. due diligence review)",
	25: "Office",
	26: "Area",
	27: "Industry",
	28: "National",
	29: "Global",
	30: "GDS - Senior",
	31: "GDS - Manager"
};

export const serviceLines = [{
	value: 0,
	label: "모든 서비스라인"
},
{
	value: 1,
	label: "Advisory"
},
{
	value: 2,
	label: "Assurance"
},
{
	value: 3,
	label: "GCO"
},
{
	value: 4,
	label: "TAS"
},
{
	value: 5,
	label: "Tax"
},
{
	value: 6,
	label: "Other"
}
];

export const serviceLinesByServiceLineCode = [{
	code: 'Not available',
	label: "사용 불가능"
},
{
	code: 'ASU',
	label: "Assurance"
},
{
	code: 'TAS',
	label: "Strategy and Transactions"
},
{
	code: 'TAX',
	label: "Tax"
},
{
	code: 'ADV',
	label: "Consulting"
},
];

export const userRanks = [{
	id: '11',
	name: "Partner"
},
{
	id: '12',
	name: "Partner"
},
{
	id: '13',
	name: "Executive Director"
},
{
	id: '21',
	name: "Sr. Manager"
},
{
	id: '32',
	name: "Manager"
},
{
	id: '36',
	name: "Tax Manager"
},
{
	id: '4',
	name: "Contractor"
},
{
	id: '41',
	name: "Senior 3"
},
{
	id: '42',
	name: "Senior"
},
{
	id: '43',
	name: "Staff 2"
},
{
	id: '44',
	name: "Staff"
},
{
	id: '45',
	name: "Senior 2"
},
{
	id: '46',
	name: "Staff 3"
},
{
	id: '49',
	name: "Associate"
},
{
	id: '5',
	name: "Admin Contractor"
},
{
	id: '51',
	name: "Intern"
},
{
	id: '52',
	name: "Admin Support"
},
{
	id: '53',
	name: "Intern (CBS)"
},
{
	id: '55',
	name: "Admin Lead"
},
{
	id: '56',
	name: "Admin Advanced"
},
{
	id: '57',
	name: "Admin Intermediate"
},
{
	id: '58',
	name: "Admin Entry"
},
{
	id: '61',
	name: "Director"
},
{
	id: '62',
	name: "Associate Director"
},
{
	id: '63',
	name: "Assistant Director"
},
{
	id: '64',
	name: "Supervising Associate"
},
{
	id: '65',
	name: "Sr. Associate"
},
{
	id: '66',
	name: "Associate"
},
{
	id: 'Not available',
	name: "사용 불가능"
}
];

export const financialAnalysis = {
	noResultFound: "선택한 옵션에 대한 결과를 찾을 수 없습니다",
	allServiceLines: "모든 서비스라인",
	allSubServiceLines: "모든 서브서비스라인",
	allMembers: "모든 멤버",
	allAvailable: "모두 가능",
	allAdded: "모두 추가됨",
	selectAll: "모두 선택",
	noResult: "결과를 찾을 수 없습니다",
	noneSelected: "선택한 항목 없음",
	clearAllSeleted: "# 선택 취소",
	showSelected: "선택 표시",
	allRanks: "모든 직급"
};

export const independenceStatus = [{
	value: 1,
	label: "미완료 - 초대되지 않음"
},
{
	value: 2,
	label: "미완료 - 진행 중"
},
{
	value: 3,
	label: "완료 - 기타"
},
{
	value: 4,
	label: "완료 - EY Canvas에서 검증됨 "
}
];

export const eycanvasIndependenceStatus = [{
	value: 1,
	label: "미완료 "
},
{
	value: 2,
	label: "식별한 문제 없음"
},
{
	value: 3,
	label: "문제 식별됨 - 조치 보류 중"
},
{
	value: 4,
	label: "문제 해결됨 - 접근 거부됨"
},
{
	value: 5,
	label: "문제 해결됨 - 접근 부여됨"
},
{
	value: 6,
	label: "해당 없음"
},
{
	value: 7,
	label: "복원됨"
},
{
	value: 8,
	label: "재지정"
},
{
	value: 9,
	label: "이전 - 식별한 문제 없음"
},
{
	value: 10,
	label: "이전 - 문제 식별됨 - 조치 보류 중"
},
{
	value: 11,
	label: "이전 - 문제 해결됨 - 접근 부여됨"
},
{
	value: 12,
	label: "이전 - 문제 해결됨 - 접근 거부됨"
}
];

export const availableUserRoles = [{
	value: 1,
	label: "Partner in Charge",
	displayOrder: 9
},
{
	value: 2,
	label: "Engagement Partner",
	displayOrder: 8
},
{
	value: 3,
	label: "Executive Director",
	displayOrder: 5
},
{
	value: 4,
	label: "Principal",
	displayOrder: 6
},
{
	value: 5,
	label: "Senior Manager",
	displayOrder: 4
},
{
	value: 6,
	label: "Manager",
	displayOrder: 3
},
{
	value: 7,
	label: "Senior",
	displayOrder: 2
},
{
	value: 8,
	label: "Staff",
	displayOrder: 1
},
{
	value: 10,
	label: "Engagement Quality Reviewer",
	displayOrder: 10
},
{
	value: 11,
	label: "Other Partner",
	displayOrder: 7
},
{
	value: 12,
	label: "GDS - Staff",
	displayOrder: 13
},
{
	value: 16,
	label: "General Counsel",
	displayOrder: 12
},
{
	value: 17,
	label: "Audit Quality Reviewer",
	displayOrder: 11
},
{
	value: 30,
	label: "GDS-Senior",
	displayOrder: 14
},
{
	value: 31,
	label: "GDS - Manager",
	displayOrder: 15
}
]

export const employmentStatus = [{
	value: 'A',
	label: "활성"
},
{
	value: 'D',
	label: "퇴직"
},
{
	value: 'L',
	label: "휴직"
},
{
	value: 'T',
	label: "퇴직"
},
{
	value: 'P',
	label: "휴직"
},
{
	value: 'R',
	label: "퇴직"
},
{
	value: 'U',
	label: "휴직"
},
]

export const independenceStatusDropdown = [{
	label: "미완료",
	options: [{
		value: 1,
		label: "미완료 - 초대되지 않음"
	},
	{
		value: 2,
		label: "미완료 - 진행 중"
	}
	]
},
{
	label: "완료",
	options: [{
		value: 3,
		label: "완료 - 기타"
	}]
}
];

export const customizedTableOptions = [{
	id: 2,
	label: "EY Canvas 독립성 상태"
},
{
	id: 3,
	label: "Member firm "
},
{
	id: 4,
	label: "국가 "
},
{
	id: 5,
	label: "청구 시간"
},
{
	id: 6,
	label: "전반적인 독립성 상태"
},
{
	id: 7,
	label: "확인일"
},
{
	id: 8,
	label: "고용 상태"
},
{
	id: 9,
	label: "업데이트한 사람"
},
{
	id: 10,
	label: "업데이트일"
}
];

export const independenceStatusChangeReasons = [{
	value: 1,
	label: "EY Canvas 외부에서 완료됨 - 식별한 문제 없음",
	isDisplayed: true
},
{
	value: 7,
	label: "EY Canvas 외부에서 완료됨 - 문제 식별됨",
	isDisplayed: true
},
{
	value: 8,
	label: "EY Canvas 외부에서 완료됨 - 문제 해결됨",
	isDisplayed: true
},
{
	value: 2,
	label: "항상 covered person임",
	isDisplayed: true
},
{
	value: 3,
	label: "더 이상 법인 소속 아님",
	isDisplayed: true
},
{
	value: 4,
	label: "휴직",
	isDisplayed: true
},
{
	value: 5,
	label: "퇴직",
	isDisplayed: false
},
{
	value: 6,
	label: "기타",
	isDisplayed: false
}
];

export const common = {
	selected: "선택됨",
	cancel: "취소",
	checkbox: {
		selectAllOn: "모두 선택",
		selectAllOff: "모두 선택 해제"
	},
	clear: "처리",
	close: "닫기",
	nav: {
		projectName: "프로젝트 이름"
	},
	pagination: {
		show: "표시",
		iconHover: {
			first: "첫 페이지",
			previous: "이전 페이지",
			next: "다음 페이지",
			last: "마지막 페이지"
		}
	},
	search: {
		clear: "검색 처리",
		buttonTitle: "검색",
		placeholder: "검색",
		noResultsPlaceholder: "결과를 찾을 수 없습니다"
	},
	table: {
		remove: "제거",
		noDataPlaceholder: "사용 가능한 데이터 없음",
		noResultsPlaceholder: "결과를 찾을 수 없습니다"
	},
	toggleSwitch: {
		no: "아니오",
		yes: "예"
	},
	wizard: {
		next: "계속",
		back: "뒤로",
		finish: "마침"
	},
	unsavedChanges: "저장되지 않은 변경사항",
	unsavedChangesDescription: "계속하면 저장되지 않은 변경사항이 지워집니다. 변경사항을 실행 취소하시겠습니까?"
};

export const project = {
	myProjects: "내 프로젝트",
	priorProjects: "전기 프로젝트",
	searchForBudgets: "검색",
	emptyContainer: "활성 예산이 없습니다. 시작하려면 '예산 생성'을 클릭하십시오.",
	noResultsFound: "결과를 찾을 수 없습니다",
	create: {
		title: "프로젝트 생성",
		clientCode: "고객 코드",
		clientCodeInfo: "미러 코드는 인식되지 않습니다. 코드를 발행한 시스템(즉, Mercury 또는 GFIS)의 코드를 사용하십시오.",
		clientName: "고객 이름",
		clientNamePlaceholder: "고객 이름을 찾으려면 고객 코드를 입력하십시오",
		name: "프로젝트 이름",
		rate: "시간당 기본 요율",
		rateInfo: "시간당 기본 요율은 예산 시간 가치를 계산하는 데 사용됩니다. 이 요율은 청구할 보수를 총 예상 시간으로 나눈 값으로 계산해야 합니다.",
		percentage: "예상 실현율",
		percentageInfo: "예상 실현율은 Mercury 또는 GFIS에 청구된 시간 가치에 적용됩니다",
		relateEngagementsInstructionalText: "이 프로젝트에 사용될 EY Canvas engagement를 하나 이상 선택하십시오. 이 engagement 지표는 재무 데이터와 함께 표시됩니다. 현재 접근 가능한 engagement만 표시됩니다.",
		selectClientAndWorkspaceInstructionalText: "이 프로젝트에 연결된 EY Canvas engagement를 식별하려면 고객과 workspace를 선택하십시오",
		engagementPanelPlaceholder: "권장 engagement를 표시하려면 고객과 workspace를 선택하십시오",
		engagementPanelNoResultsFound: "결과를 찾을 수 없습니다",
		emptyEngagements: "사용 가능한 EY Canvas engagement 없음. 시작하려면 EY Canvas에 신규 engagement를 생성하십시오.",
		selectClient: "고객 선택",
		selectWorkspace: "Workspace를 선택하십시오",
		selectEngagements: "Engagement 선택",
		selectedEngagements: "추가된 engagement",
		selectedEngagementError: "계속하려면 engagement를 하나 이상 선택하십시오",
		searchEngagements: "Engagement 검색",
		searchUsers: "사용자 검색",
		engagementLabel: "{0} | ID: {1}",
		addBtn: "추가",
		removeBtn: "제거",
		clientLbl: "고객",
		engagementCodeLbl: "Engagement 코드",
		engagementTypeCodeLbl: "Engagement 유형",
		engagementNameLbl: "Engagement 이름",
		engagementId: "ID",
		addedByLbl: "추가한 사람",
		engagementDescriptionLbl: "Engagement 설명",
		systemLbl: "시스템",
		noEngagementsLabel: "Engagement 코드를 이 프로젝트에 연결",
		step4InstTxt: "프로젝트에 연결할 engagement 코드를 하나 이상 선택하십시오",
		relatedEngagementCodesSubtitle: "연결된 Engagement 코드",
		relatedEngagementCodeLink: "Mercury 또는 GFIS의 engagement 코드 연결. 미러 코드는 인식되지 않습니다.",
		unauthorizedModalHeader: "권한 없는 사용자",
		unauthorizedText: "연결할 권한이 없습니다",
		allowedUsersText: "다음은 이 작업을 할 수 있는 사람 목록입니다",
		closeBtn: "닫기",
		validateBtn: "검증",
		relatedEngagementAddLabel: "Mercury 또는 GFIS의 engagement 코드 연결. 미러 코드는 인식되지 않습니다.",
		todayLbl: "오늘",
		NoEmailMessage: "제공된 이메일 없음",
		noEngagementsAdded: "추가된 engagement 없음",
		selectToImport: "이 프로젝트에 사용자를 불러오려면 EY Canvas engagement를 선택하십시오",
		addMember: "사용자가 EY Canvas engagement에서 활동 상태가 아닌 경우, 그들을 추가하려면 {0}하십시오",
		addedMembers: "추가된 멤버",
		employeeName: "멤버",
		role: "역할",
		manageTeamInstructionalText: "연결된 EY Canvas engagement에서 활동 팀 멤버를 선택하고 아래 설명에 따라 EY Canvas engagement에 속하지 않는 다른 팀 멤버를 추가하십시오",
		currentUser: "현재 사용자",
		canvasEngagements: "EY Canvas engagement",
		wizardSteps: [
		{
			stepName: "단계 1",
			stepDescription: "프로젝트 세부정보 입력",
			active: true
		},
		{
			stepName: "단계 2",
			stepDescription: "EY Canvas engagement 선택"
		},
		{
			stepName: "단계 3",
			stepDescription: "접근 관리",
			relatedEngagementCodesSubtitle: "연결된 Engagement 코드",
			relatedEngagementCodeLink: "Mercury 또는 GFIS의 engagement 코드 연결. 미러 코드는 인식되지 않습니다.",
			unauthorizedModalHeader: "권한 없는 사용자",
			unauthorizedText: "연결할 권한이 없습니다",
			allowedUsersText: "다음은 이 작업을 할 수 있는 개인 목록입니다",
			close: "닫기"
		},
		{
			stepName: "단계 4",
			stepDescription: "Mercury/GFIS에 연결"
		},
		{
			stepName: 'Step 5',
			stepDescription: "Engagement 코드를 EY Canvas engagement에 연결하십시오",
			isExit: true
		}
		],
		ratePerHour: "시간당 요율",
		realizationPercentage: "실현율"
	},
	stepOne: {
		enterProjectName: "계속하려면 프로젝트 이름을 입력하십시오"
	},
	stepTwo: {
		addCanvasEngagements: "프로젝트에 EY Canvas engagement 추가",
		editCanvasEngagements: "프로젝트에 대한 EY Canvas engagement 편집",
		selectCanvasEngagements: "접근 권한이 있는 EY Canvas engagement가 표시됩니다. 프로젝트에 포함할 EY Canvas engagement를 하나 이상 선택하십시오.",
		noCanvasEngagements: "사용 가능한 EY Canvas engagement 없음. 프로젝트를 계속 설정하려면 다음 단계로 진행하십시오.",
		noCanvasEngagementsSelected: "EY Canvas engagement가 선택되지 않았습니다",
		noSearchResultsFoundLeftRail: "결과를 찾을 수 없습니다",
		clientName: "고객",
		workspace: "Workspace",
		engagementCode: "Engagement 코드",
		canvasEngagementName: "EY Canvas Engagement",
		changes: "변경사항",
		tooltipMessages: {
			clientName: "고객 이름",
			clientCode: "고객 코드",
			engagementCode: "Engagement 코드",
			engagementDescription: "Engagement 이름",
			workspaceID: "Workspace ID",
			workspaceDescription: "Workspace 이름"
		}
	},
	stepThree: {
		editTeamMembers: "프로젝트 팀 멤버 편집",
		editTeamMembersWhoWillHaveAccess: "프로젝트에 접근 권한을 가질 팀 멤버를 편집하십시오. 연결된 EY Canvas engagement에 속하지 않은 팀 멤버를 추가하려면, 오른쪽에 있는 검색 기능을 사용하십시오. 프로젝트 관리자는 프로젝트를 관리할 수 있습니다(예, 팀 멤버 추가 또는 제거).",
		addTeamMembers: "프로젝트에 팀 멤버 추가",
		addTeamMembersWhoWillHaveAccess: "프로젝트에 접근 권한을 가질 팀 멤버를 추가하십시오. 연결된 EY Canvas engagement에 속하지 않는 팀 멤버를 추가하려면 오른쪽에 있는 검색 기능을 사용하십시오. 프로젝트 관리자는 프로젝트를 관리할 수 있습니다 (예, 팀 멤버 추가 또는 제거).",
		noCanvasEngagementsSelected: "EY Canvas engagement가 선택되지 않았습니다",
		noSearchResultsFoundLeftRail: "결과를 찾을 수 없습니다",
		addOtherTeamMembers: "연결된 EY Canvas engagement에 속하지 않는 다른 팀 멤버 추가",
		member: "멤버",
		projectAdministrator: "프로젝트 관리자",
		clickHere: "여기를 클릭하십시오",
		nameOrEmail: "이름 또는 이메일",
		addNewMember: "추가",
		firstName: "이름",
		lastName: "성",
		inviteAndClose: "초대 & 닫기",
		inviteAndAddAnother: "초대 & 더 추가",
		clear: "처리"
	},
	stepFour: {
		engagementCode: "Engagement 코드",
		clientName: "고객",
		validation: "상태",
		independenceOnly: "독립성 전용",
		noEngagementCodes: "프로젝트에 추가된 engagement 코드 없음",
		addNewMember: "추가",
		addEngagementManually: "Engagement 코드 추가",
		addEngagementCodes: "Engagement 코드 추가",
		editEngagementCodes: "Engagement 코드 편집",
		validateEngagement: "추가된 engagement 코드를 모두 검증합니다. GFIS/Mercury에서 귀하에게 접근권한이 있는 engagement 코드만 검증할 수 있습니다. Engagement 코드가 \'독립성 전용\'으로 식별되면, 이 engagement와 관련된 세부정보(팀 멤버, 관련 청구 시간 등)는 이 Economics 프로젝트의 독립성 요약에 포함되지만 재무 관련 정보에는 포함되지 않습니다.",
		informationalMessage: "Mercury는 engagement 코드 앞에 engagement 유형을 포함합니다 (예, E-12345678)",
		noCanvasEngagements: "EY Canvas engagement가 프로젝트에 추가되지 않았습니다",
		engagementCodePlaceholder: "Engagement 코드 입력",
		validate: "검증",
		engagementCodeRequired: "Engagement 코드 필요",
		searchNoResults: "결과를 찾을 수 없습니다"
	},
	stepFive: {
		title: "Engagement 코드를 EY Canvas engagement에 연결하십시오",
		description: "각 EY Canvas engagement와 연결된 primary engagement 코드는 아래에 표시됩니다. EY Canvas engagement에 추가 engagement 코드를 연결하려면 아래 끌어서 놓기 기능을 사용하십시오.",
		financialCodes: {
			searchButtonTitle: "검색",
			searchButtonPlaceholder: "재무 engagement 코드로 검색",
			header: "Engagement 코드",
			noRecords: "식별된 engagement 코드 없음",
			canvasEngagements: "EY Canvas engagement",
			noResults: "결과를 찾을 수 없습니다"
		},
		canvasEngagements: {
			searchButtonTitle: "검색",
			clearButtonTitle: "처리",
			noResults: "결과를 찾을 수 없습니다",
			searchButtonPlaceholder: "고객 또는 EY Canvas engagement로 검색",
			header: "고객 및 engagement",
			noRecords: "프로젝트에 연결된 EY Canvas engagement 없음",
			noEngagementCodes: "연결된 engagement 코드 없음",
			primary: "Primary",
			displayUnassociatedEngagements: "연결된 재무 코드가 없는 EY Canvas engagement 표시"
		}
	},
	deleteProject: "프로젝트 삭제",
	deleteDescription: "모든 사용자에 대해 프로젝트를 삭제하시겠습니까?",
	deleteDescText: "이 작업은 실행 취소할 수 없습니다.",
	delete: "삭제",
	cancel: "취소",
	close: "닫기",
	confirm: "확인",
	leaveProject: "나가기",
	leaveDescription: "이 프로젝트에서 나가시겠습니까? 팀 멤버는 계속 사용할 수 있습니다.",
	change: "변경",
	changes: "변경사항"
};

export const users = {
	settings: {
		title: "사용자 설정",
		firstName: "이름",
		lastName: "성",
		displayLanguage: "표시 언어",
		numberFormat: "숫자 형식",
		negativeNumberFormat: "음수 형식",
		currencyFormat: "통화 형식",
		dateFormat: "날짜 형식",
		roundingFormat: "반올림 형식",
		save: "저장",
		cancel: "취소",
		errorMessageSelect: "값을 선택하십시오",
		errorMessageInput: "유효한 값을 입력하십시오",
		isRequired: "은(는) 필수입니다",
		preferences: "기본 설정",
		yourDelegates: "귀하의 대리인",
		yourDelegatesDescription: "귀하가 접근할 수 있는 engagement 코드에 대한 재무 데이터를 Mercury 또는 GFIS에서 검색할 권한을 부여받은 사용자",
		delegationsFromOthers: "타인의 위임",
		delegationsFromOthersDescription: "그들이 접근할 수 있는 engagement 코드에 대한 재무 데이터를 Mercury 또는 GFIS에서 검색할 권한을 귀하에게 부여한 사용자",
		noUsersIdentified: "식별된 사용자 없음",
		addADelegate: "대리인 추가",
		theme: "테마",
		preferredCurrency: "기본 통화",
		status: "상태"
	}
};

export const projectSummary = {
	filter: {
		filterFinancialAuditData: "고객 필터",
		filter: "필터",
		searchPlaceholder: "검색",
		searchClearHoverText: "처리",
		searchHoverText: "검색",
		unvalidated: "검증되지 않음",
		noData: "연결된 EY Canvas engagement 없음",
		noResults: "결과를 찾을 수 없습니다",
		noInformationAvailable: "선택한 옵션에 사용 가능한 정보 없음",
		independence: "독립성",
		noDataFound: "데이터를 찾을 수 없습니다",
	},
	roundingType: "반올림:",
	roundingFormats: {
		none: "없음",
		thousands: "천",
		millions: "백만",
		lakhs: "십만",
		crores: "천만"
	},
	updatedDateType: {
		financialDateLabel: "재무 데이터",
		updatedOn: "updated on",
		canvasDateLabel: "EY Canvas 데이터"
	},
	keyPerformanceIndicators: {
		noValue: '-',
		totalEngagementRevenue: {
			ter: "TER",
			actualTER: "실제 TER",
			billed: "청구됨",
			actualBilling: "실제 청구",
			totalEngagementRevenue: "총 engagement 수익 (보수 + 비용)",
			forecastedTER: "예측 TER"
		},
		margin: {
			margin: "마진",
			target: "대상"
		},
		globalDeliveryService: {
			gds: "GDS 사용",
			globalDeliveryService: "Global Delivery Service"
		}
	},
	currency: "통화:",
	globalCurrency: "Global",
	localCurrency: "로컬",
	noDataAvailable: "선택한 필터에 사용 가능한 데이터 없음",
	actualHours: "실제 시간",
	etc: "ETC",
	ftaVariance: "FTA 차이",
	completedTasks: "완료 task",
	closedAssignments: "닫힌 배정",
	acceptedRequests: "수락된 요청사항",
	gDSUsage: "GDS 사용",
	summaryHeaderPartner: "Partner",
	summaryHeaderPpedd: "PPEDD",
	summaryHeaderExecutive: "Executive",
	financialProgressCard: {
		financialProgress: "재무적 진행상태",
		financialDetails: "세부재무정보",
		ansr: "ANSR",
		nsr: "NSR",
		ansrTooltip: "Adjusted net standard revenue (비용을 제외한 순 보수)",
		nsrTooltip: "Net Standard Revenue (개별 순 표준 요율 x 시간)",
		eafTooltip: "Engagement 조정 요소",
		cost: "원가",
		hours: "시간",
		expandDetails: "세부정보 확장",
		expand: "확장",
		collapse: "축소",
		collapseDetails: "세부정보 축소",
		margin: "마진",
		marginPercentage: "마진",
		rphAcronym: "RPH",
		cphAcronym: "CPH",
		mphAcronym: "MPH",
		eafAcronym: "EAF",
		actual: "실제",
		budgeted: "예산",
		forecasted: "예측",
		ftaVariance: "FTA 차이",
		ftaVarianceTooltip: "예측 대 실적 차이",
		rph: "시간당 요율",
		cph: "시간당 원가",
		mph: "시간당 마진",
		ansrCost: "NSR / Cost",
		serviceLine: "서비스라인",
		subServiceLine: "서브서비스라인",
		teamMember: "팀 멤버",
		totalAnsr: "총 NSR",
		totalCost: "총 원가",
		totalHours: "총 시간",
		ansrLabelText: "Net Standard Revenue",
		rank: "직급",
		performanceActuals: "실제 성과 "
	},
	financialAnalysis: {
		show: "표시",
		first: "처음",
		last: "마지막",
		previous: "이전",
		next: "다음"
	},
	financialFilters: {
		serviceLine: "서비스라인",
		subServiceLine: "서브서비스라인",
		rank: "직급",
		teamMember: "팀 멤버",
		showMore: "기타",
		clear: "처리",
		clearAll: "모두 처리",
		search: "검색",
		noResultsPlaceholder: "결과 없음",
		noFiltersAvailable: "필터 없음",
		yes: "예",
		no: "아니오",
		tooltip: "필터",
		expenseType: "비용 유형 "
	},
	billingAndExpenses: {
		title: "실제 누적 청구",
		forecastedTer: "예측 TER",
		forecastedTerTooltip: "예측 Total Engagement Revenue (보수 + 비용)",
		forecastedBilling: "예측 청구",
		collected: "회수됨",
		collectedTooltip: "회수됨 / 청구됨",
		unCollected: "미회수됨",
		unCollectedTooltip: "미회수됨 / 청구됨",
		billed: "청구됨 (미결제)",
		billedTooltip: "청구됨 / 예측 TER",
		billedTotal: "청구됨",
		unbilled: "미청구",
		unbilledTooltip: "미청구 / 예측 TER",
		engagementCode: "Engagement 코드",
		invoiceDate: "청구일",
		currency: "통화",
		invoiceNumber: "청구번호",
		amount: "금액",
		noInformationPlaceholder: "선택한 옵션에 사용 가능한 정보 없음",
		actualTer: "실제 TER",
		actualTerTooltip: "실제 total engagement revenue (보수 + 비용)",
		actualExpenseToDate: "실제 누적 비용",
		displayBy: "데이터 표시 기준",
		expenseType: "비용 유형",
		teamMember: "팀 멤버",
		totalExpenseToDate: "총 누적 비용",
		expenseTypeColumn: "비용 유형",
		teamMemberColumn: "팀 멤버",
		globalExpenseAmount: "글로벌 비용 금액",
		localExpenseAmount: "로컬 비용 금액",
		billingSummary: "청구 요약",
		billingStatus: "청구 상태",
		billingTER: "TER",
		serviceLine: "서비스라인",
		serviceLineColumn: "서비스라인",
		rank: "직급",
		rankColumn: "직급 "
	},
	independence: {
		teamMember: "팀 멤버",
		hoursCharged: "청구 시간",
		independenceStatus: "전반적인 독립성 상태",
		confirmationDate: "확인일",
		memberFirm: "Member firm",
		eyCanvasIndependenceStatus: "EY Canvas 독립성 상태",
		employmentStatus: "고용 상태",
		country: "국가",
		updatedBy: "업데이트한 사람",
		updatedDate: "업데이트 날짜",
		selectColumns: "열 선택",
		confirmationDateBefore: "다음 전 확인일",
		confirmationDateAfter: "다음 후 확인일",
		excelsummary: "요약",
		excelMercury: "Murcury 데이터",
		excelCanvas: "Canvas 데이터",
		name: "이름",
		gui: "GUI",
		rank: "직급",
		emailAddress: "이메일 주소",
		clarification: "Clarification",
		explanation: "설명",
		updatedOn: "업데이트일",
		client: "고객",
		mercuryEngagementCode: "Mercury engagement 코드",
		canvasEngagement: "Canvas engagement",
		email: "이메일",
		reason: "사유",
		engagementRole: "Engagement 역할",
		location: "위치",
		filter: {
			unassociatedFinancialCodes: "연결되지 않은 재무코드",
			unassociatedLabel: "연결되지 않음",
			filterHeader: "독립성 필터",
			noFinancialCodeLabel: "연결된 재무코드 없음",
			noEngagementLabel: "연결된 EY Canvas engagement 없음",
			expandText: "확장",
			collapseText: "축소",
			noDataFound: "데이터를 찾을 수 없습니다"
		}
	},
	header: {
		hours: "시간",
		actualHours: "실제",
		forecastedHours: "예측",
		variance: "FTA 차이",
		other: "Other",
		ppedd: "PPEDD",
		mgrSrMgr: "SrMgr/Mgr",
		partnerHours: "Partner 시간",
		executiveDirector: "Executive Director",
		seniorManager: "Senior Manager",
		manager: "Manager",
		senior: "Senior",
		staff: "Staff",
		intern: "Intern",
		billed: "청구됨:",
		ter: "TER:",
		forecastedTER: "예측 TER:",
		margin: "마진",
		ansr: "ANSR",
		cost: "원가",
		terSection: "TER",
		billedSection: "청구됨",
		forecastedTERSection: "예측",
		forecastedTERSectionForHeader: "예측 TER",
		completedTasks: "완료 task",
		completedAssignments: "닫힌 배정",
		acceptedRequests: "수락된 요청사항",
		gdsUsage: "GDS 사용",
		completedTasksTooltip: "완료됨",
		totalTasksTooltip: "총",
		completedAssignmentsTooltip: "닫힘",
		totalAssignmentsTooltip: "총",
		acceptedRequestsTooltip: "수락됨",
		sentRequestsTooltip: "전송됨",
		gdsHoursTooltip: "GDS",
		actualHoursTooltip: "실제 시간",
		otherTooltip: "Other",
		otherHeaderTooltip: "Other",
		ppeddTooltip: "PPEDD",
		mgrSrMgrTooltip: "SrMgr/Mgr",
		partnerHoursTooltip: "Partner/Principal",
		executiveDirectorTooltip: "ED/D",
		seniorManagerTooltip: "Sr. Manager",
		managerTooltip: "Manager",
		seniorTooltip: "Senior",
		staffTooltip: "Staff",
		internTooltip: "Intern",
		varianceTooltip: "예측 대 실제 차이",
		ansrTooltip: "Adjusted net standard revenue (비용을 제외한 순 보수)",
		marginTooltip: "Margin = (ANSR - Cost) / ANSR",
		terSectionHover: "실제 total engagement revenue (보수 + 비용)",
		forecastedTERSectionHover: "예측 total engagement revenue (보수 + 비용)",
		billedSectionHover: "실제 net invoice amount",
		gdsUsageHover: "Global Delivery Service 사용"
	}
};

export const exportOptions = {
	buttonText: "내보내기",
	downloadCSV: "CSV 다운로드",
	downloadJPEG: "JPEG 다운로드",
	downloadPDF: "PDF 다운로드",
	downloadPNG: "PNG 다운로드",
	downloadSVG: "SVG 다운로드",
	downloadXLS: "XLS 다운로드",
	exitFullscreen: "전체 화면 종료",
	viewFullscreen: "전체 화면 보기",
	printChart: "차트 인쇄"
};

export const adminLabels = {
	adminPortal: "관리",
	usersTab: "사용자 관리",
	projectsTab: "프로젝트 관리",
	administrators: "관리자 관리"
};

export const projectUserStatus = {
	active: "활동",
	inactive: "비활동"
};

export const projectUserRoles = {
	defaultUser: "기본 사용자",
	projectAdministrator: "프로젝트 관리자"
};

export const projectStatus = {
	active: "활동",
	deleted: "삭제됨"
};

export const administratorRoles = {
	none: "없음",
	adminReader: "관리 판독자",
	adminWriter: "관리 작성자",
	superAdmin: "수퍼 관리자"
}

export const addUser = {
	firstName: "이름",
	lastName: "성",
	enterFirstNameText: "사용자의 이름, 성 또는 이메일 주소를 입력한 후 Enter 키를 눌러 검색합니다",
	selectRole: "역할",
	userRole: "사용자 역할",
	clear: "처리",
	email: "이메일",
	role: "역할",
	cancel: "취소",
	addUser: "사용자 추가",
	close: "닫기",
	add: "추가",
	addAdministrator: "관리자 추가",
	error1: "선택한 사용자는 프로젝트에 이미 속해 있습니다 검토하십시오.",
	error2: "관리자는 특별 사용자 계정만 될 수 있습니다"
};

export const adminManageProjects = {
	manageProjects: "프로젝트 관리",
	description: "프로젝트 ID를 입력하여 프로젝트 검색",
	projectId: "프로젝트 ID",
	search: "검색",
	clearSearch: "처리",
	enterValidProject: "유효한 프로젝트 ID 입력",
	projectDetails: "프로젝트 세부정보",
	enterProjectName: "프로젝트 이름 입력",
	projectName: "프로젝트 이름",
	projectStatus: "프로젝트 상태",
	financialCodes: "재무 코드",
	noFinancialCodes: "이 프로젝트에 재무 engagement 코드가 매핑되지 않았습니다",
	engagementCode: "Engagement 코드",
	client: "고객",
	status: "상태",
	validatedBy: "검증한 사람",
	canvasEngagements: "EY Canvas engagement",
	canvasEngagement: "EY Canvas engagement",
	noCanvasEngagements: "이 프로젝트에 EY Canvas engagement가 매핑되지 않았습니다",
	member: "멤버",
	gui: "GUI",
	firstName: "이름",
	lastName: "성",
	emailAddress: "이메일 주소",
	userRole: "사용자 역할",
	validated: "검증됨",
	unvalidated: "검증되지 않음",
	enterValidGui: "프로젝트 ID에 유효한 GUI 입력",
	requiredProjectName: "프로젝트 이름은 비워둘 수 없습니다",
	successToastMessage: "변경사항 저장됨",
	resetToastMessage: "재설정 완료됨",
	errorToastMessage: "한 명 이상의 프로젝트 멤버는 프로젝트 관리자가 되어야 합니다. 변경사항을 검토하십시오.",
	independenceOnly: "독립성 전용",
	yes: "예",
	no: "아니오"
};

export const manageAdministrators = {
	title: "관리자 관리",
	firstName: "이름",
	lastName: "성",
	email: "이메일",
	role: "역할",
	description: "신규 관리자 추가 또는 기존 관리자 관리",
	noInformationPlaceholder: "선택한 옵션에 사용 가능한 정보 없음",
	updateAdminErrorToast: "업데이트에 실패했습니다. 검토 후 다시 시도하십시오",
	updateAdminSuccessToast: "변경사항 저장됨",
};

export const adminManageUsers = {
	title: "사용자 관리",
	description: "사용자 GUI를 입력하여 사용자 검색",
	inputLabel: "사용자 GUI",
	searchButtonLabel: "검색",
	cancelButtonLabel: "처리",
	errorMessage: "유효한 사용자 GUI 입력",
	userDetails: "사용자 세부정보",
	projects: "프로젝트",
	delegates: "대리인",
	settings: "설정",
	noResultsPlaceholder: "기록을 찾을 수 없습니다",
	delegatedTo: "위임 대상:",
	delegatedFrom: "위임자:",
	gui: "GUI",
	firstName: "이름",
	lastName: "성",
	emailAddress: "이메일 주소",
	projectName: "프로젝트 이름",
	projectId: "프로젝트 ID"
};

export const adminCommon = {
	save: "저장",
	reset: "재설정"
}
